const idMessages = {
  "nav": {
    "home": "Beranda",
    "start": "Mulai",
    "learning": "Pusat Belajar",
    "support": "Dukungan Orang Tua",
    "buy": "Beli",
    "about": "Tentang Kami",
    "admin": "Admin"
  },
  "hero": {
    "title": "GENIUS AI",
    "subtitle": "Partner Pembelajaran Bahasa Cerdas Anak Anda",
    "description": "Robot pembelajaran bahasa AI yang dirancang khusus untuk anak-anak usia 4-13 tahun, aman, menyenangkan, dan efektif",
    "cta": "Mulai",
    "learnMore": "Pelajari Lebih Lanjut"
  },
  "start": {
    "hero": {
      "title": "Mulai Menggunakan GENIUS AI",
      "subtitle": "Manual Produk + Pengenalan Produk + Cara Penggunaan + Video Pengenalan"
  },
  "product": {
      "title": "Pengenalan Produk",
      "description": "Robot pembelajaran bahasa cerdas yang dirancang khusus untuk anak-anak usia 4-13 tahun, dengan desain bulat yang lucu dan casing silikon yang aman."
    },
    "setup": {
      "title": "Panduan Pengaturan",
      "step1": {
        "title": "Buka Kotak",
        "description": "Buka kemasan dan keluarkan perangkat GENIUS AI"
      },
      "step2": {
        "title": "Nyalakan",
        "description": "Tekan dan tahan tombol power selama 3 detik untuk menyalakan"
      },
      "step3": {
        "title": "Hubungkan",
        "description": "Ikuti petunjuk di layar untuk menghubungkan WiFi"
      },
      "step4": {
        "title": "Atur",
        "description": "Buat akun orang tua dan atur profil anak"
      }
    },
    "videos": {
      "title": "Tutorial Video"
    },
    "faq": {
      "title": "Pertanyaan yang Sering Diajukan"
    },
    "features": {
      "design": "Dirancang untuk anak usia 4-13 tahun",
      "safety": "Casing silikon yang aman", 
      "ai": "Teman Guru AI Lily"
    },
    "showcase": {
      "title": "Pameran Produk GENIUS AI"
    },
    "videoList": {
      "intro": "Video Pengenalan Produk",
      "setup": "Tutorial Pengaturan Pertama",
      "features": "Pengenalan Fitur Dasar"
    },
    "watchVideo": "Tonton Video",
    "faqItems": {
      "charge": {
        "question": "Bagaimana cara mengisi daya perangkat?",
        "answer": "Gunakan charger magnetik yang disertakan, letakkan di dekat bagian bawah perangkat untuk pengisian magnetik otomatis."
      },
      "age": {
        "question": "Berapa usia yang cocok untuk perangkat ini?",
        "answer": "GENIUS AI dirancang untuk anak-anak usia 4-13 tahun, menyediakan konten pembelajaran yang sesuai untuk kelompok usia yang berbeda."
      },
      "setup": {
        "question": "Bagaimana cara mengatur perangkat?",
        "answer": "Silakan merujuk ke panduan pengaturan di halaman Mulai, atau tonton tutorial video."
      }
    },
    "cta": {
      "title": "Siap untuk Memulai?",
      "subtitle": "Beli GENIUS AI sekarang, biarkan anak-anak memulai perjalanan pembelajaran bahasa yang menyenangkan",
      "buy": "Beli Sekarang",
      "learnMore": "Pelajari Lebih Lanjut"
    }
  },
  "learning": {
    "hero": {
      "title": "Pusat Belajar",
      "subtitle": "Fitur Belajar + Guru AI + Kerangka Pendidikan + Download Materi"
    },
    "lily": {
      "title": "Guru AI Lily",
      "description": "Lily adalah guru AI yang lucu, lembut dan sabar, pandai berinteraksi dengan anak-anak, dan dapat memberikan pengalaman pembelajaran yang dipersonalisasi berdasarkan karakteristik setiap anak."
    },
    "framework": {
      "title": "Kerangka Pendidikan"
    },
    "features": {
      "title": "Fitur Pembelajaran"
    },
    "materials": {
      "title": "Download Materi Pembelajaran",
      "description": "Kami menyediakan materi pembelajaran yang dapat diunduh untuk membantu anak-anak belajar offline dan membantu orang tua dalam mengajar."
    },
    "cta": {
      "title": "Pengalaman Online",
      "description": "Rasakan kekuatan GENIUS AI dan nikmati pesona pembelajaran cerdas!",
      "button": "Rasakan Sekarang"
    },
    "lilyFeatures": [
      "Dialog Suara",
      "Pengajaran Personal",
      "Pelacakan Kemajuan",
      "Teman Emosional"
    ],
    "lilyName": "Guru Lily",
    "learningFeatures": [
      {
        "title": "Pembelajaran Kosakata",
        "description": "Belajar kosakata baru melalui gambar, pengucapan dan permainan interaktif"
      },
      {
        "title": "Latihan Dialog",
        "description": "Berlatih dialog skenario nyata dengan Guru AI Lily"
      },
      {
        "title": "Membaca Cerita",
        "description": "Perpustakaan cerita bilingual yang kaya untuk meningkatkan minat membaca"
      },
      {
        "title": "Permainan Interaktif",
        "description": "Konsolidasi pembelajaran melalui permainan yang menyenangkan"
      }
    ],
    "ageGroups": [
      {
        "age": "4-6 tahun",
        "title": "Tahap Dasar",
        "description": "Pembelajaran kosakata dasar dan latihan pengucapan melalui lagu anak-anak dan cerita sederhana"
      },
      {
        "age": "6-10 tahun",
        "title": "Tahap Dasar",
        "description": "Latihan dialog sehari-hari dan simulasi skenario, memperluas kosakata dan pengetahuan tata bahasa"
      },
      {
        "age": "10-13 tahun",
        "title": "Tahap Lanjutan",
        "description": "Pembelajaran bahasa lanjutan dan eksplorasi budaya, mengembangkan pemikiran mandiri dan keterampilan ekspresi"
      }
    ],
    "downloads": [
      {
        "name": "Kartu Belajar (PDF)",
        "description": "Kartu belajar yang dapat dicetak untuk membantu anak-anak belajar offline"
      },
      {
        "name": "Buku Latihan (PDF)",
        "description": "Buku latihan yang sesuai untuk mengkonsolidasikan hasil pembelajaran"
      },
      {
        "name": "Wallpaper Guru Lily (JPG)",
        "description": "Wallpaper Guru Lily yang lucu untuk membuat anak-anak lebih menyukai"
      }
    ],
    "downloadButton": "Unduh",
    "startButton": "Mulai"
  },
  "support": {
    "hero": {
      "title": "Dukungan Orang Tua",
      "subtitle": "Panduan Orang Tua + Pusat Bantuan + Panduan Interaksi"
    },
    "philosophy": {
      "title": "Filosofi Pendidikan",
      "vision": {
        "title": "Visi Pendidikan",
        "description": "Membuat setiap anak usia 4-13 tahun dapat menikmati pengalaman pembelajaran bahasa yang aman, menyenangkan, dan dipersonalisasi"
      },
      "safety": {
        "title": "Jaminan Keamanan",
        "description": "Perangkat menggunakan bahan silikon food-grade, layar pelindung mata bebas blue light, kontrol konten yang ketat"
      },
      "effectiveness": {
        "title": "Efektivitas Pembelajaran",
        "description": "Melalui pengajaran personal AI dan interaksi gamifikasi, secara signifikan meningkatkan minat pembelajaran bahasa anak"
      }
    },
    "control": {
      "title": "Fitur Kontrol Orang Tua"
    },
    "experts": {
      "title": "Rekomendasi Ahli"
    },
    "faq": {
      "title": "Pertanyaan yang Sering Diajukan"
    },
    "contact": {
      "title": "Hubungi Kami",
      "description": "Kami melayani Anda 24 jam"
    },
    "tips": {
      "title": "Tips Interaksi"
    },
    "parentFeatures": [
      {
        "title": "Rekomendasi Waktu Penggunaan",
        "description": "Waktu penggunaan harian yang disarankan untuk melindungi kesehatan mata anak"
      },
      {
        "title": "Melihat Kemajuan Pembelajaran",
        "description": "Melihat kemajuan pembelajaran dan prestasi anak"
      },
      {
        "title": "Filter Keamanan Konten",
        "description": "Memastikan semua konten pembelajaran sesuai untuk anak-anak"
      },
      {
        "title": "Manajemen Perangkat",
        "description": "Mengelola pengaturan perangkat melalui aplikasi mobile"
      },
      {
        "title": "Laporan Pembelajaran",
        "description": "Menghasilkan laporan pembelajaran detail secara berkala"
      },
      {
        "title": "Penetapan Tujuan",
        "description": "Menetapkan tujuan pembelajaran dan hadiah untuk anak"
      }
    ],
    "expertTestimonials": [
      {
        "title": "Ahli Psikologi Anak",
        "quote": "Desain GENIUS AI mempertimbangkan sepenuhnya karakteristik perkembangan kognitif anak, dan metode interaksinya dapat secara efektif merangsang minat belajar anak."
      },
      {
        "title": "Profesor Pendidikan Bahasa",
        "quote": "Robot ini memberikan anak-anak lingkungan bahasa yang imersif dan merupakan suplemen yang kuat untuk pengajaran tradisional."
      }
    ],
    "faqItems": [
      {
        "question": "Bagaimana cara mengatur perangkat?",
        "answer": "Silakan merujuk ke panduan pengaturan di halaman Mulai atau tonton tutorial video."
      },
      {
        "question": "Bagaimana cara berinteraksi dengan anak?",
        "answer": "Disarankan orang tua menemani anak menggunakan perangkat bersama-sama, mendorong anak berbicara dengan Guru Lily, dan secara teratur memeriksa kemajuan pembelajaran."
      },
      {
        "question": "Bagaimana cara melihat kemajuan pembelajaran?",
        "answer": "Anda dapat melihat kemajuan pembelajaran dan prestasi anak melalui layar perangkat."
      },
      {
        "question": "Bagaimana cara mengatur waktu penggunaan?",
        "answer": "Disarankan orang tua mengatur waktu penggunaan secara wajar sesuai usia anak untuk melindungi kesehatan mata anak."
      },
      {
        "question": "Bagaimana cara menghubungi layanan pelanggan?",
        "answer": "Anda dapat menghubungi tim layanan pelanggan kami melalui email, telepon atau WhatsApp, kami melayani Anda 24 jam sehari."
      }
    ],
    "contactInfo": {
      "email": "Email",
      "phone": "Telepon",
      "serviceTime": "Jam Layanan",
      "serviceHours": "Senin sampai Jumat 9:00-18:00"
    },
    "interactionTips": [
      {
        "title": "Belajar Bersama",
        "content": "Habiskan 15-30 menit dengan anak Anda menggunakan GENIUS AI setiap hari, berpartisipasi dalam proses pembelajaran mereka."
      },
      {
        "title": "Dorong Ekspresi",
        "content": "Dorong anak-anak untuk berbicara dengan berani, bahkan jika ada kesalahan, berikan umpan balik positif."
      },
      {
        "title": "Ciptakan Konteks",
        "content": "Ciptakan skenario penggunaan bahasa dalam kehidupan sehari-hari, seperti menonton animasi bilingual bersama, bermain permainan peran."
      },
      {
        "title": "Bimbingan Sabar",
        "content": "Ketika anak-anak menghadapi kesulitan, berikan bimbingan sabar alih-alih langsung memberikan jawaban."
      }
    ]
  },
  "buy": {
    "hero": {
      "title": "Pilih Paket Anda",
      "subtitle": "Pilih paket pembelajaran yang paling sesuai untuk anak Anda, mulai perjalanan pembelajaran cerdas"
    },
    "plans": {
      "title": "Pilih Paket"
    },
    "package": {
      "title": "GENIUS AI",
      "subtitle": "Fitur Pembelajaran Lengkap",
      "price": "Rp 499,000",
      "originalPrice": "Rp 899,000",
      "discount": "Penawaran Terbatas",
      "savings": "Hemat Rp 400,000",
      "features": [
        "Fitur Pembelajaran Lengkap",
        "Guru AI Lily",
        "Semua Konten Pembelajaran",
        "Penggunaan Gratis Seumur Hidup",
        "Desain Aman"
      ],
      "buyButton": "Beli Sekarang"
    },
    "showcase": {
      "title": "Pameran Produk"
    },
    "benefits": {
      "discount": {
        "title": "🎁 Penawaran Terbatas",
        "description": "Beli sekarang dan nikmati harga penawaran terbatas, hemat Rp 400,000!"
      },
      "shipping": {
        "title": "🚚 Pengiriman Gratis",
        "description": "Pengiriman gratis ke seluruh Indonesia, dikirim dalam 7 hari, mendukung pembayaran tunai saat diterima."
      },
      "warranty": {
        "title": "🛡️ Jaminan Kualitas",
        "description": "Garansi 1 tahun, pengembalian tanpa alasan 30 hari, pembelian tanpa khawatir."
      }
    },
    "process": {
      "title": "Proses Pembelian",
      "steps": [
        {
          "title": "Pilih Paket",
          "description": "Pilih paket pembelajaran yang sesuai untuk anak Anda"
        },
        {
          "title": "Isi Informasi",
          "description": "Isi alamat pengiriman dan informasi kontak"
        },
        {
          "title": "Bayar Pesanan",
          "description": "Pilih metode pembayaran untuk menyelesaikan pembayaran"
        },
        {
          "title": "Mulai Belajar",
          "description": "Mulai perjalanan pembelajaran Anda setelah menerima produk"
        }
      ]
    },
    "cta": {
      "title": "Beli GENIUS AI Sekarang",
      "subtitle": "Beli sekarang dan nikmati penawaran terbatas, biarkan anak-anak memulai perjalanan pembelajaran bahasa yang menyenangkan!",
      "buyButton": "Beli Sekarang - Rp 499,000",
      "learnMoreButton": "Pelajari Lebih Lanjut"
    }
  },
  "about": {
    "hero": {
      "title": "Tentang Kami",
      "subtitle": "Berdedikasi untuk membuat pembelajaran bahasa anak-anak menjadi lebih menyenangkan, aman, dan efektif"
    },
    "mission": {
      "title": "Misi",
      "description": "Membuat setiap anak usia 4-13 tahun dapat menikmati pengalaman pembelajaran bahasa yang aman, menyenangkan, dan dipersonalisasi, membuat pembelajaran lebih menarik dan efektif melalui teknologi AI."
    },
    "vision": {
      "title": "Visi",
      "description": "Menjadi penyedia solusi pembelajaran bahasa cerdas terkemuka di Indonesia untuk anak-anak, mempromosikan inovasi dan pengembangan teknologi pendidikan, memungkinkan setiap anak belajar dengan bahagia."
    },
    "team": {
      "title": "Tim Inti"
    },
    "value": {
      "title": "Nilai-Nilai Inti"
    },
    "history": {
      "title": "Sejarah Perkembangan"
    },
    "partner": {
      "title": "Mitra Indonesia"
    },
    "contact": {
      "title": "Hubungi Kami"
    },
    "cta": {
      "title": "Bergabung dengan Tim Kami",
      "description": "Kami mencari mitra berbakat untuk menciptakan masa depan pembelajaran anak-anak yang lebih baik bersama",
      "buttonPrimary": "Pelajari Produk",
      "buttonSecondary": "Bergabung"
    },
    "teamMembers": [
      {
        "name": "Dr. Zhang",
        "role": "CEO & Pendiri",
        "description": "Ahli pendidikan anak dengan 15 tahun pengalaman di industri pendidikan, fokus pada R&D teknologi AI pendidikan.",
        "avatar": "👨‍💼"
      },
      {
        "name": "Insinyur Li",
        "role": "CTO & Direktur Teknis",
        "description": "Ahli teknologi AI, mantan insinyur Google, fokus pada pengembangan teknologi AI yang aman untuk anak-anak.",
        "avatar": "👨‍💻"
      },
      {
        "name": "Desainer Wang",
        "role": "Direktur Desain",
        "description": "Ahli desain produk anak-anak, fokus pada desain antarmuka yang ramah anak dan pengalaman pengguna.",
        "avatar": "👩‍🎨"
      }
    ],
    "values": [
      {
        "icon": "🛡️",
        "title": "Keamanan Pertama",
        "description": "Keamanan anak-anak adalah pertimbangan terpenting kami, semua produk menjalani pengujian keamanan yang ketat."
      },
      {
        "icon": "👥",
        "title": "Berpusat pada Pengguna",
        "description": "Berpusat pada kebutuhan anak-anak dan orang tua, terus mengoptimalkan pengalaman produk."
      },
      {
        "icon": "🚀",
        "title": "Inovasi Berkelanjutan",
        "description": "Terus mengeksplorasi teknologi baru, mengintegrasikan teknologi canggih seperti AI dan pengenalan suara ke dalam pendidikan."
      },
      {
        "icon": "🤝",
        "title": "Kolaborasi Tim",
        "description": "Percaya pada kekuatan kerja tim, menciptakan produk yang lebih baik melalui kolaborasi."
      }
    ],
    "timeline": [
      {
        "year": "2022",
        "title": "Perusahaan Didirikan",
        "description": "Perusahaan didirikan, fokus pada R&D teknologi AI pendidikan anak-anak, menerima investasi angel round."
      },
      {
        "year": "2023",
        "title": "Pengembangan Produk",
        "description": "Menyelesaikan pendanaan Seri A, tim diperluas menjadi 50 orang, pengembangan prototipe produk GENIUS AI selesai."
      },
      {
        "year": "2024",
        "title": "Peluncuran Produk",
        "description": "Produk GENIUS AI secara resmi diluncurkan, mendapat pujian luas dari pengguna Indonesia, jumlah pengguna melebihi 10.000."
      },
      {
        "year": "Masa Depan",
        "title": "Rencana Ekspansi",
        "description": "Berencana untuk memperluas ke lebih banyak negara Asia Tenggara, menjadi platform pembelajaran cerdas anak-anak terdepan di kawasan."
      }
    ],
    "partners": [
      {
        "name": "Grup Pendidikan Indonesia",
        "description": "Berkemitraan dengan grup pendidikan terbesar di Indonesia untuk menyediakan solusi yang disesuaikan untuk sekolah.",
        "logo": "🏫"
      },
      {
        "name": "Taman Teknologi Jakarta",
        "description": "Berlokasi di Taman Teknologi Jakarta, menikmati dukungan kebijakan dan sumber daya industri.",
        "logo": "🏢"
      },
      {
        "name": "Mitra Ritel",
        "description": "Berkemitraan dengan pengecer utama Indonesia untuk memperluas saluran penjualan produk.",
        "logo": "🛒"
      }
    ],
    "contactInfo": {
      "email": "Email",
      "phone": "Telepon",
      "address": "Alamat",
      "location": "Kirana Three Office Tower, Jakarta",
      "viewOnMaps": "Lihat di Google Maps"
    }
  },
  "features": {
    "title": "Mengapa Memilih GENIUS AI?",
    "lily": {
      "title": "Guru AI Lily",
      "description": "Guru AI yang lucu menemani pembelajaran, lembut dan sabar, pandai berinteraksi dengan anak-anak"
    },
    "safety": {
      "title": "Aman dan Terpercaya",
      "description": "Fitur keamanan yang dirancang khusus untuk anak-anak, bahan silikon food-grade, orang tua tenang"
    },
    "fun": {
      "title": "Pembelajaran Menyenangkan",
      "description": "Belajar bahasa melalui gamifikasi, membuat anak-anak mencintai pembelajaran"
    }
  },
  "testimonials": {
    "title": "Rekomendasi Orang Tua",
    "sarah": {
      "name": "Ibu Sarah",
      "location": "Jakarta",
      "quote": "Anak saya sangat menyukai Guru Lily, efek pembelajaran sangat bagus! Perangkatnya sangat aman, saya benar-benar tenang membiarkan anak saya menggunakannya."
    },
    "michael": {
      "name": "Ayah Michael",
      "location": "Surabaya",
      "quote": "GENIUS AI membuat anak saya sangat tertarik belajar bahasa Mandarin, setiap hari mereka menantikan berbicara dengan Guru Lily."
    }
  },
  "cta": {
    "title": "Siap untuk Memulai?",
    "subtitle": "Beli GENIUS AI sekarang, biarkan anak-anak memulai perjalanan pembelajaran bahasa yang menyenangkan",
    "button": "Beli Sekarang",
    "learnMore": "Pelajari Lebih Lanjut"
  },
  "footer": {
    "description": "GENIUS AI - Robot Pembelajaran Bahasa Cerdas untuk Anak Usia 4-13 Tahun",
    "rights": "Hak Cipta © 2024 GENIUS AI",
    "tagline": "Membuat pembelajaran lebih menyenangkan.",
    "developedBy": "Dikembangkan oleh perusahaan Infant.AI",
    "privacyPolicy": "Kebijakan Privasi",
    "termsOfService": "Syarat Layanan",
    "cookiePolicy": "Kebijakan Cookie"
  }
}

export default idMessages